module.exports = __webpack_public_path__ + "img/unlimited-section.22bc2122.svg";